module.exports = __webpack_public_path__ + "static/media/not_eligible.fdcc6083.svg";